import React, { useState } from "react";
import { Select, Spin } from "antd";
import { getOrAddCapexUserByEmail, searchByNameAd } from "api";

const { Option } = Select;

let timeout;
let currentValue;

const PersonSearchAd = ({
	value,
	onChange,
	defaultOptions,
	options = {},
	style,
	placeholder = "Search for a person by their name (lastname, firstname)",
}) => {
	const [data, setData] = useState(defaultOptions);
	const [email, setEmail] = useState(value);
	const [loading, setLoading] = useState(false);

	const { valueKey, outProp, includeLabel, disabled } = options;

	function fetch(value, callback) {
		if (timeout) {
			clearTimeout(timeout);
			timeout = null;
		}
		currentValue = value;

		const query = async () => {
			setLoading(true);
			const response = await searchByNameAd({
				name: value,
			});
			if (currentValue === value) {
				const data = [];
				response.forEach((r) => {
					data.push({
						value: valueKey ? r[valueKey] : r["EmailAddress"],
						text: r["Surname"] + ", " + r["GivenName"],
					});
				});
				callback(data);
			}
			setLoading(false);
		};
		timeout = setTimeout(query, 300);
	}

	const onSearch = (name) => {
		if (name) {
			fetch(name, (data) => setData(data));
		} else {
			setData([]);
		}
	};

	const triggerChange = async (email) => {
		setEmail(email);
		const returnUser = await getOrAddCapexUserByEmail({ email });
		const id = returnUser.Id;
		if (includeLabel)
			onChange?.({
				id,
				text: data.find((d) => d.value === email)?.text,
				email,
				[outProp]: returnUser[outProp],
			});
		else onChange?.(returnUser[outProp] ?? id);
	};

	const selectOptions =
		data && data.length > 0
			? data
					.sort((a, b) =>
						a.text === b.text ? 0 : a.text > b.text ? 1 : -1
					)
					.map((d, key) => {
						return (
							<Option key={key} value={d.value}>
								{d.text}
							</Option>
						);
					})
			: null;

	return (
		<>
			<Select
				showSearch
				defaultValue={email || undefined}
				placeholder={placeholder}
				style={style}
				defaultActiveFirstOption={false}
				showArrow={false}
				filterOption={false}
				onSearch={onSearch}
				onChange={triggerChange}
				notFoundContent={null}
				disabled={disabled}
				suffixIcon={loading ? <Spin /> : null}
			>
				{selectOptions}
			</Select>
			{loading && (
				<div style={{ marginTop: 10 }}>
					<Spin />
				</div>
			)}
		</>
	);
};

export default PersonSearchAd;
